<template>
  <ProjectTabCharter
    :projectName="projectName"
    :signees="charterSignees"
    @sentCharter="reloadProjectDetails"
  />
</template>

<script>
import { mapGetters } from "vuex";

import ProjectTabCharter from "@/components/ProjectTabCharter.vue";

export default {
  components: {
    ProjectTabCharter
  },
  props: {
    projectSummary: { type: Object, required: true }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getDataLoading',
      hasLoaded: 'getDataLoaded',
    }),
    project() {
      return this.projectSummary.project;
    },
    projectId() {
      return this.project.projectId;
    },
    projectName() {
      return this.project.projectName;
    },
    projectUsers() {
      return this.projectSummary.projectUsers;
    },
    charterSignees() {
      const approvedCharters = this.projectSummary.charterRelations.filter(user => user.approveCharterDate);
      
      return approvedCharters.map(signee => {
        return this.projectUsers.find(user => user.userId === signee.userId);
      });
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    setupPage() {
      this.$store.dispatch('dataLoaded');
    },
    reloadProjectDetails() {
      this.$parent.getProjectDetails();
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
